<template>
  <v-app bar :class="{ 'bg-yellowBack': $route.name === 'login' }">
    <Head>
      <Title>Soma</Title>
    </Head>
    <template v-if="appStore.movingVersions">
      <!-- Just display white screen, to give off an illusion of longer loading time, but actually we're disguising the redirect to other version, so it doesnt flicker -->
      <div></div>
    </template>
    <template v-else>
      <NuxtLayout>
        <nuxt-page />
      </NuxtLayout>
      <cookie-consent-banner />
      <prompt-modal />
    </template>
  </v-app>
</template>

<script>
import { useAppStore } from "~/stores/appStore"
import { useUserStore } from "~/stores/userStore"
import { useCookieConsentUpdate } from "~/composables/useCookieConsentUpdate"

export default {
  setup() {
    window.userOnline = true
    const userStore = useUserStore()
    const appStore = useAppStore()
    userStore.init()
    useCookieConsentUpdate()
    setInterval((_) => userStore.reload({ successCallback: useCookieConsentUpdate }), 1000 * 60 * 15)
    return {
      appStore,
      userStore,
    }
  },
}
</script>

<style lang="sass">
@import "~/assets/css/vuetify/components.sass"
@import "~/assets/css/application.sass"
</style>
